/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Schedule } from './schedule';
import { ParameterData } from './parameterData';
import { VirtualFenceConstructionRule } from './virtualFenceConstructionRule';


export interface ConfigFileDssModel { 
    deviceId: string;
    deviceTypeId?: string;
    dropOffConnectedCollarId?: string;
    dropOffType?: ConfigFileDssModel.DropOffTypeEnum;
    parameterDataList?: Array<ParameterData>;
    schedules?: Array<Schedule>;
    timestamp: string;
    vfConstructionRules?: Array<VirtualFenceConstructionRule>;
}
export namespace ConfigFileDssModel {
    export const DropOffTypeEnum = {
        Internal: 'INTERNAL',
        External: 'EXTERNAL'
    } as const;
    export type DropOffTypeEnum = typeof DropOffTypeEnum[keyof typeof DropOffTypeEnum];
}


export type DropOffTypeEnum = typeof ConfigFileDssModel.DropOffTypeEnum[keyof typeof ConfigFileDssModel.DropOffTypeEnum];
